<template>
<div class="chapter">
<div class="inner_page">
<p class="chap" id="toc"><b>Table of Contents</b></p>
<p class="tx"> </p>
<p class="tx"> </p>
<p class="center">___________________</p>
<p class="tx"> </p>
<p class="tx"> </p>
<p class="toc"><a href="#/Text/script">Great Scripture</a></p>
<p class="toc"><a href="#/Text/chap1">1. Every Boy Should Have a Man</a></p>
<p class="toc"><a href="#/Text/chap2">2. His Female Man</a></p>
<p class="toc"><span href="#/Text/chap3" title="Link target outside of Sample">3. A Proper Kennel</span></p>
<p class="toc"><span href="#/Text/chap4" title="Link target outside of Sample">4. His Musical Man</span></p>
<p class="toc"><span href="#/Text/chap5" title="Link target outside of Sample">5. Red Man, Red Man, Why Do You Weep?</span></p>
<p class="toc"><span href="#/Text/chap6" title="Link target outside of Sample">6. The Bridge</span></p>
<p class="toc"><span href="#/Text/chap7" title="Link target outside of Sample">7. Man at War</span></p>
<p class="toc"><span href="#/Text/chap8" title="Link target outside of Sample">8. In Fever in War</span></p>
<p class="toc"><span href="#/Text/chap9" title="Link target outside of Sample">9. Their World Shall Pass Away</span></p>
<p class="toc"><span href="#/Text/chap10" title="Link target outside of Sample">10. Mans of the Snow</span></p>
<p class="toc"><span href="#/Text/chap11" title="Link target outside of Sample">11. Red Locks</span></p>
<p class="toc"><span href="#/Text/chap12" title="Link target outside of Sample">12. The Oaf</span></p>
<p class="toc"><span href="#/Text/chap13" title="Link target outside of Sample">13. Jack</span></p>
<p class="toc"><span href="#/Text/chap14" title="Link target outside of Sample">14. Mike</span></p>
<p class="toc"><span href="#/Text/apoc" title="Link target outside of Sample">Apocrypha</span></p>
<p class="toc1"><span href="#/Text/apoc1" title="Link target outside of Sample">Sing oh Sing of Great Lord Uulf</span></p>
<p class="toc1"><span href="#/Text/apoc2" title="Link target outside of Sample">Great Lord Uulf Is Brought Down Low</span></p>
<p class="toc1"><span href="#/Text/apoc3" title="Link target outside of Sample">The Death Song of Great Lord Uulf</span></p>
<p class="toc1"><span href="#/Text/apoc4" title="Link target outside of Sample">Life Song of Great Lord Gerwargerulf</span></p>
<p class="toc1"><span href="#/Text/apoc5" title="Link target outside of Sample">Harp Song 104</span></p>
<p class="toc1"><span href="#/Text/apoc6" title="Link target outside of Sample">I Do My Goodness Do</span></p>
<p class="toc1"><span href="#/Text/apoc7" title="Link target outside of Sample">Three Little Man Mans</span></p>
<p class="toc1"><span href="#/Text/apoc8" title="Link target outside of Sample">Mikel</span></p>
<p class="toc"><span href="#/Text/bonus" title="Link target outside of Sample">Bonus: Excerpt from <i>Jesus Boy</i></span></p>
<p class="toc"><span href="#/Text/allnothing" title="Link target outside of Sample">Also by Preston L. Allen</span></p>
<p class="toc"><span href="#/Text/bio" title="Link target outside of Sample">About Preston L. Allen</span></p>
<p class="toc"><span href="#/Text/akb" title="Link target outside of Sample">About Akashic Books</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5da667c4